var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDetailCard',{attrs:{"title-item-list":_vm.titleItemList,"body-content-list":_vm.bodyContentList,"body-content-styles":_vm.bodyContentStyles}})
}
var staticRenderFns = []

export { render, staticRenderFns }